module.exports = __webpack_public_path__ + "static/logo-14914f54a7c54b994ba567516a92be92.svg";